/**
 * A error corresponding to the given HTTP status code.
 *
 * HTTP request processing handlers may raise this error. The {@link renderHttpError error handler} would render
 * corresponding error page then.
 *
 * @see HttpConfig.errorHandler
 */
export class HttpError extends Error {
    #statusCode;
    #statusMessage;
    #details;
    /**
     * Constructs HTTP status error.
     *
     * @param statusCode - HTTP status code.
     * @param options - HTTP error options.
     */
    constructor(statusCode, options = {}) {
        super(httpErrorMessage(statusCode, options), options);
        this.name = 'HttpError';
        this.#statusCode = statusCode;
        this.#statusMessage = options.statusMessage;
        this.#details = options.details;
    }
    /**
     * HTTP status code.
     */
    get statusCode() {
        return this.#statusCode;
    }
    /**
     * HTTP status message.
     */
    get statusMessage() {
        return this.#statusMessage;
    }
    /**
     * Error details.
     *
     * This will be displayed on error page in addition to error code.
     */
    get details() {
        return this.#details;
    }
    /**
     * Performs additional message processing before it is logged.
     *
     * At output or default logging stage replaces this error with error message, details, and reason. Does nothing at
     * other logging stages.
     *
     * @returns Either new loggable value representation, or nothing outside the output logging stage.
     */
    toLog({ on = 'out' }) {
        if (on !== 'out') {
            return;
        }
        const report = [this.message];
        const { details, cause } = this;
        if (details) {
            report.push(details);
        }
        if (cause) {
            report.push(cause);
        }
        return report;
    }
}
function httpErrorMessage(statusCode, { statusMessage, message = statusMessage ? `${statusCode} ${statusMessage}` : `${statusCode}`, }) {
    return message;
}
//# sourceMappingURL=http-error.js.map